import React from 'react';

export default function Voxuy() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_5435)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M22.5726 8.27642V15.866L20.4105 17.1146V9.52186L13.8387 5.72863C13.8387 5.72863 14.3318 5.44414 14.3381 5.44098C15.3749 4.84986 16.6457 4.85303 17.6762 5.45046L22.5726 8.27642ZM17.6761 26.6073L18.1629 26.326H18.1597L11.5879 22.5327V14.9399L9.42578 16.1885V23.7782L14.3633 26.6294C15.3938 27.2047 16.655 27.1952 17.6761 26.6073ZM26.0002 19.8649V19.3054L19.4253 23.0987L12.8535 19.3054V21.7995L19.4284 25.5959L24.3249 22.7699C25.3617 22.1693 26.0002 21.063 26.0002 19.8649ZM19.1467 12.7494V10.2522H19.1435L12.5749 6.45892L7.6785 9.28804C6.64169 9.88547 6 10.9918 6 12.193V12.7525L12.5749 8.95613L19.1467 12.7494ZM14.7371 11.6651L8.16214 15.4615V23.0479L7.6785 22.7698C6.64169 22.1692 6 21.0628 6 19.8648V14.2097L12.5749 10.4165L14.7371 11.6651ZM25.9993 17.8448V12.1929C25.9993 10.998 25.3671 9.89484 24.3366 9.29425C24.3334 9.29425 23.8372 9.00659 23.8372 9.00659V16.5994L17.2686 20.3926L19.4275 21.6381L25.9993 17.8448Z'
        fill='url(#paint1_linear_5201_5435)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_5435'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#3F21FF' />
          <stop offset='1' stop-color='#341DC8' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_5435'
          x1='5.84547'
          y1='0.468494'
          x2='22.3667'
          y2='22.4288'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
